// extracted by mini-css-extract-plugin
module.exports = {"modalBtns":"MainModal_modalBtns__2EQX0","LogInBtn":"MainModal_LogInBtn__130Yy","SignupBtn":"MainModal_SignupBtn__2Nwzc"};